export default "__VITE_ASSET__9ec577e5__"